import { useTransition, useCallback } from 'react'

/**
 * Hook personalizado para manejar transiciones del juego con React 18
 * Proporciona una API optimizada para transiciones no urgentes
 */
export const useGameTransition = () => {
  const [isPending, startTransition] = useTransition()

  const executeTransition = useCallback((callback) => {
    startTransition(() => {
      callback()
    })
  }, [startTransition])

  const executeDelayedTransition = useCallback((callback, delay = 0) => {
    setTimeout(() => {
      startTransition(() => {
        callback()
      })
    }, delay)
  }, [startTransition])

  return {
    isPending,
    executeTransition,
    executeDelayedTransition,
    startTransition
  }
}

export default useGameTransition